// src/pages/CasebookDynamic.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getCasebookByCustomUrl } from "../api/CasebookApi";
import ScrollTop from "./ScrollTop";
import Content from "../components/ContentHeader.js";
import Route from "../components/Route.js";
import Slogan from "./Slogan";

function CasebookDynamic() {
  const { custom_url } = useParams();
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      try {
        const result = await getCasebookByCustomUrl(custom_url);
        if (result.error === "Not found") {
          navigate("/"); // 메인으로 이동하거나, "/not-found" 등으로 이동
          return;
        }
        setData(result);
      } catch (e) {
        console.error("불러오기 실패", e);
      }
    };
    fetch();
  }, [custom_url, navigate]);

  if (!data) return <div>로딩 중...</div>;

  return (
    <div className="casebook_page">
      <ScrollTop />

      <Content
        title="CASEBOOK"
        title1={
          <p className="content-title1">
            생성형 AI 도입 사례가 궁금하다면?
            <br />
            지금 사례집 신청하고, 실제 RAG 적용법을 확인해보세요.
          </p>
        }
      />

      <Route route1="MEDIA" route2="CASEBOOK"></Route>

      <div className="content_bg">
        <h1>생성형 AI · RPA 도입 사례 리포트 | 레인보우브레인 CASEBOOK</h1>
        <div className="container">
          <div className="casebook_wrap">
            <div className="casebook_left">
              <div className="left_img">
                <img src={data.img} alt="로딩 중..." />
              </div>
              <div
                className="contents2"
                dangerouslySetInnerHTML={{ __html: data.content }}
              />
            </div>
            <iframe
              src={data.link}
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Google Form"
            />
          </div>
        </div>
      </div>

      <Slogan containerPadding="5vw 0" />
    </div>
  );
}

export default CasebookDynamic;
